import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-edit-marche",
  templateUrl: "./edit-marche.component.html",
  styleUrls: ["./edit-marche.component.scss"],
})
export class EditMarcheComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
